"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSharedShower = function SvgSharedShower(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5H6.583a1 1 0 0 0-1 1v.076a1 1 0 0 0 1 1H10.5m3-2.076h4.021a1 1 0 0 1 1 1v.076a1 1 0 0 1-1 1H13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.467a4.012 4.012 0 0 1 4.012 4.011v1.11M12 1.02v21.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.873 14.316-3.424 7.185m11-7.185 3.424 7.185m-9.508-6.851-1.57 6.7m5.805-6.601 1.706 6.475",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.517 10.555V9.442A3.934 3.934 0 0 1 10.45 5.51"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSharedShower);
var _default = exports["default"] = Memo;